<div [class.hidden]="!show">
    <div class="loader-overlay">
        <div *ngIf="show" class="loader"></div>
    </div>
</div>
<!-- <div class="progress-loader" [hidden]="!loading">
    <div class="loading-spinner">
        <img src="https://loading.io/mod/spinner/gear-set/index.svg">
        <span class="loading-message">Please wait...</span>
    </div>
</div> -->